import { render, staticRenderFns } from "./FeedbackManagement.vue?vue&type=template&id=05732ba7&scoped=true&"
import script from "./FeedbackManagement.vue?vue&type=script&lang=js&"
export * from "./FeedbackManagement.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackManagement.vue?vue&type=style&index=0&id=05732ba7&lang=less&scoped=true&"
import style1 from "./FeedbackManagement.vue?vue&type=style&index=1&id=05732ba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05732ba7",
  null
  
)

export default component.exports